import {mapState} from "vuex";

export default {
  mutations: {
    ...mapState({
      user: state => state.Authenticate.user,
      tenant_id: state => state.Authenticate.tenant_id,
    })
  },
  computed: {
    paymentPermission() {
      return !(this.user.billing_active === false && ['owner', 'vendor'].includes(this.user.user_role))
    },
    accountEnabledPermission() {
      return !(this.user.disabled_by_agent_owner === true && ['vendor'].includes(this.user.user_role))
    }
  }
}